import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import { OrderingListPendingProductRequestViewModel, ApproveOrderingListRequestProductCommand, CancelOrderingListRequestProductCommand } from 'Api/CoreApi';

@Component({
    template: "#ordering-list-request-product-detail-template"
})
export default class OrderingListRequestProductDetailComponent extends Vue {
    
    @Prop()
    requestProduct: OrderingListPendingProductRequestViewModel;
    
    confirmCancelElementTxt : HTMLElement;
    
    async created() {
        
    }
    
    async mounted(){
        this.confirmCancelElementTxt = document.getElementById('orderinglistrequestsproduct_confirm_delete_txt');
    }
    
    async approve(isAvailable: boolean){
        await store.dispatch.orderingListRequestProduct.approve(new ApproveOrderingListRequestProductCommand({
            productKey: this.requestProduct.productKey,
            isAvailable: isAvailable
        }));
    }
    
    async cancel(){
        const msg = this.confirmCancelElementTxt.innerText.replace('{0}', this.requestProduct.productKey);
        
        if(confirm(msg)){
            await store.dispatch.orderingListRequestProduct.cancel(new CancelOrderingListRequestProductCommand({
                productKey: this.requestProduct.productKey
            }));
        }
    }
    
    
}

Vue.component('ordering-list-request-product-detail', OrderingListRequestProductDetailComponent);